var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1125 8.46777H4V6.96777H13.1125L11.95 5.80527L13 4.71777L16 7.71777L13 10.7178L11.95 9.63027L13.1125 8.46777ZM9.25 5.46777V2.46777H1.75V12.9678H9.25V9.96777H10.75V12.9678C10.75 13.3803 10.6031 13.7334 10.3094 14.0271C10.0156 14.3209 9.6625 14.4678 9.25 14.4678H1.75C1.3375 14.4678 0.984375 14.3209 0.690625 14.0271C0.396875 13.7334 0.25 13.3803 0.25 12.9678V2.46777C0.25 2.05527 0.396875 1.70215 0.690625 1.4084C0.984375 1.11465 1.3375 0.967773 1.75 0.967773H9.25C9.6625 0.967773 10.0156 1.11465 10.3094 1.4084C10.6031 1.70215 10.75 2.05527 10.75 2.46777V5.46777H9.25Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.821eb261181a1483b6fa3fa9e4b50edd.svg";
export { ForwardRef as ReactComponent };